@if (totalItems > 0) {
  <div class="flex items-center justify-between text-sm text-[#4e7a97]">
    <div class="pl-2">
      {{ totalItems }} Total
    </div>
    <div class="flex items-center space-x-1">
      <!-- First Page -->
      <button
        (click)="goToPage(0)"
        [disabled]="currentPage === 0"
        class="w-6 h-6 flex items-center justify-center rounded
               text-[#4e7a97] hover:text-[#0e161b]
               disabled:opacity-30 text-lg bg-[#e7eef3]"
      >
        &#xab;
      </button>

      <!-- Previous -->
      <button
        (click)="goToPage(currentPage - 1)"
        [disabled]="currentPage === 0"
        class="w-6 h-6 flex items-center justify-center rounded
               text-[#4e7a97] hover:text-[#0e161b]
               disabled:opacity-30 text-lg bg-[#e7eef3]"
      >
        &#8249;
      </button>

      <!-- Page Numbers -->
      @for (page of [].constructor(totalPages); track $index) {
        <button
          (click)="goToPage($index)"
          class="w-6 h-6 flex items-center justify-center rounded text-lg bg-[#e7eef3]"
          [class.text-[#0e161b]]="currentPage === $index"
          [class.font-semibold]="currentPage === $index"
          [class.text-[#4e7a97]]="currentPage !== $index"
          [class.hover:text-[#0e161b]]="currentPage !== $index"
        >
          {{ $index + 1 }}
        </button>
      }

      <!-- Next -->
      <button
        (click)="goToPage(currentPage + 1)"
        [disabled]="currentPage + 1 === totalPages"
        class="w-6 h-6 flex items-center justify-center rounded
               text-[#4e7a97] hover:text-[#0e161b]
               disabled:opacity-30 text-lg bg-[#e7eef3]"
      >
        &#8250;
      </button>

      <!-- Last Page -->
      <button
        (click)="goToPage(totalPages - 1)"
        [disabled]="currentPage + 1 === totalPages"
        class="w-6 h-6 flex items-center justify-center rounded
               text-[#4e7a97] hover:text-[#0e161b]
               disabled:opacity-30 text-lg bg-[#e7eef3]"
      >
        &#xbb;
      </button>
    </div>
  </div>
}
